import { useFormContext } from "react-hook-form";
import { ObjectFormInput, ObjectFormRadio } from "..";
import { FormType } from "../../types/form-type.ts";

export function ObjectFormGeneral() {
  const { control } = useFormContext<FormType>();

  return (
    <div className="form-section form-body">
      <ObjectFormInput
        label="Краткое наименование объекта"
        control={control}
        name="shortName"
        style={{
          width: "50%",
        }}
        inputProps={{
          disabled: true,
        }}
      />
      <ObjectFormInput
        label="Наименование объекта капитального строительства в соответствии с проектной документацией"
        control={control}
        name="fullName"
        inputProps={{
          disabled: true,
        }}
      />
      <ObjectFormInput
        label="Краткие проектные характеристики"
        control={control}
        name="descriptionProjects"
      />
      <ObjectFormInput
        label="Описание этапа строительства, реконструкции (необ.)"
        control={control}
        name="descriptionStage"
      />
      <ObjectFormRadio
        name="constructionType"
        label="Вид строительства"
        control={control}
        radioOptions={[
          { title: "Строительство", value: "CONSTRUCTION" },
          {
            title: "Реконструкция",
            value: "RECONSTRUCTION",
            disabled: true,
          },
          {
            title: "Капитальный ремонт",
            value: "RENOVATION",
            disabled: true,
          },
        ]}
      />
    </div>
  );
}
